// 先于一切渲染注册 antd React 19 兼容补丁（修复静态 message/notification 不渲染）
import "./antdReact19Patch";
import React from "react";
import { createRoot } from "react-dom/client";
import Root from "./Root";

createRoot(document.getElementById("root")!).render(<Root />);
